import { css } from '@emotion/react';
import { List, styled } from '@mui/material';

import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';

export const StyledList = styled(List)(
  ({ theme }) => css`
    color: inherit;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(2)};
    font-weight: 500;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      flex-direction: row;
      justify-content: flex-end;
      padding: 0;
    }
  `,
);
